// extracted by mini-css-extract-plugin
module.exports = {"container":"modal_container__24KkV","inside":"modal_inside__3cPQc","header":"modal_header__2fFNh"};